module.exports = " <div class=pages> <router-view keep-alive></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Main.vue
// module id = 285
// module chunks = 5